export { TabTouchLogo } from './TabTouchLogo'
export { TheGameLogo } from './TheGameLogo'
export { WestAustralian } from './WestAustralian'
export { McDonaldsLogo } from './McDonaldsLogo'
